/* Paneles laterales (drawers) de detalles de producto.
   Maneja: mover drawers al body, llenar ficha técnica automática, abrir/cerrar. */
(function () {
  function init() {
    /* 1) Mover todos los drawers al <body> — evita que un contenedor con transform
          rompa el position:fixed y el panel salga a media página */
    document.querySelectorAll('.dp-drawer').forEach(function (d) {
      if (d.parentElement !== document.body) document.body.appendChild(d);
    });

    /* 2) Ficha técnica automática por modelo (solo si no hubo metafield ni metaobject) */
    document.querySelectorAll('[data-dp-specs-auto]').forEach(function (row) {
      if (!window.DP_SPECS) return;
      var target = row.getAttribute('data-dp-open');
      var drawer = document.getElementById(target);
      if (!drawer) return;

      var title = drawer.getAttribute('data-dp-model') || '';
      var key = title.toLowerCase()
        .split(/[·•\-–—]/)[0]
        .replace(/\bsamsung\b/g, '')
        .replace(/\bapple\b/g, '')
        .replace(/\bunlocked\b/g, '')
        .replace(/\b\d+\s?(gb|tb)\b/g, '')
        .replace(/[()]/g, '')
        .replace(/[^a-z0-9+ ]/g, '')
        .replace(/\s+/g, ' ')
        .trim();

      var specs = window.DP_SPECS[key];
      if (!specs) return;

      var body = drawer.querySelector('.dp-drawer-body');
      if (body) {
        body.innerHTML = specs.map(function (p) {
          return '<div class="dp-spec-row"><span class="dp-spec-k">' + p[0] +
                 '</span><span class="dp-spec-v">' + p[1] + '</span></div>';
        }).join('');
      }
      row.hidden = false;
      var wrap = row.closest('.dp-details-wrap');
      if (wrap) wrap.hidden = false;
    });

    /* 3) Ocultar el contenedor de las filas que quedaron sin contenido */
    document.querySelectorAll('.dp-details-wrap').forEach(function (wrap) {
      var row = wrap.querySelector('.dp-details-row');
      if (row && row.hidden) wrap.hidden = true;
    });
  }

  /* 4) Abrir / cerrar (delegado, funciona con cualquier cantidad de bloques) */
  var current = null;

  function open(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.add('open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('dp-drawer-lock');
    current = d;
  }

  function close() {
    if (!current) return;
    current.classList.remove('open');
    current.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('dp-drawer-lock');
    current = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-dp-open]');
    if (opener) { open(opener.getAttribute('data-dp-open')); return; }

    if (e.target.closest('[data-dp-close]')) { close(); return; }

    /* Clic fuera del panel (dentro de un drawer abierto) cierra */
    var insideDrawer = e.target.closest('.dp-drawer');
    if (insideDrawer && !e.target.closest('.dp-drawer-panel')) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-inicializar cuando Shopify re-renderiza en el editor de temas */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
